export default __webpack_public_path__ + "static/media/landscape.162ee434.jpg";